<template>
  <div class="content">
    <h1>数字证书状态信息查询服务</h1>
    <div class="search">
      <el-input
        v-model="certificateNo"
        prefix-icon="el-icon-search"
        placeholder="请输入证书编号"
      ></el-input
      ><el-button type="primary" @click="search" :loading="loading">{{
        searchStr
      }}</el-button>
    </div>
    <div v-show="currentState" class="result">
      <div class="title">查询结果</div>
      <span>当前状态为：</span
      ><span :class="currentState">{{
        currentState | filterCurrentState
      }}</span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "HelloWorld",
  data() {
    return {
      certificateNo: "",
      loading: false,
      searchStr: "查询",
      currentState: "",
    };
  },
  props: {
    msg: String,
  },
  methods: {
    search() {
      if (!this.certificateNo) {
        this.$message.warning("请输入证书编号");
        return;
      }
      this.loading = true;
      axios
        .get("/api/getCaStatus", {
          params: {
            certSN: this.certificateNo,
          },
        })
        .then(({ data }) => {
          this.currentState = data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.$message.error(error.msg);
          this.loading = false;
        });
    },
  },
  filters: {
    filterCurrentState(val) {
      if (val === "USING") {
        return "正常";
      } else if (val === "REVOKED") {
        return "已撤销";
      } else if (val === "UNKNOW") {
        return "未知";
      } else {
        return "未知";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.content {
  text-align: center;
}
.search .el-input {
  width: 40%;
}
>>> .el-input .el-input__inner {
  border-width: 2px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-right: 0px;
}
.search .el-button {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.result {
  margin-top: 20px;
}
.result .title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 20px;
}
.USING {
  color: #42b983;
}
.REVOKED {
  color: red;
}
</style>
